import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { MadAuthService } from "../../mad-auth/mad-auth.service";
import { HttpUtilsService } from "../../_base/crud";
import { TemplateRequest, TemplateResponse, ToeTemplateModel } from "../_models";
import { SubdomainService } from "../../_base/subdomain.service";


@Injectable()
export class ToeTemplateService {
    API_URL = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/templates/toes`;
    constructor(
        private http: HttpClient,
        private authService: MadAuthService,
        private subDomainService: SubdomainService
    ) {}

    getAll(request: TemplateRequest): Observable<TemplateResponse<ToeTemplateModel>> {
        const headers = this.authService.getAuthHeaders();
        const params = new HttpParams()
            .set("page", request.pageNumber.toString())
            .set("pageSize", request.pageSize.toString())
            .set("agency", request.agencyID ? request.agencyID.toString() : "-1");

        return this.http.get<{
            data: ToeTemplateModel[],
            pagination: {
                total: number
            }
        }>(this.API_URL, {
            headers,
            params
        }).pipe(
            map(res => {
                const tres: TemplateResponse<ToeTemplateModel> = {
                    templates: res.data,
                    total: res.pagination.total
                }
                return tres;
            })
        )
    }

    get(id: number): Observable<ToeTemplateModel> {
        const headers = this.authService.getAuthHeaders();
        return this.http.get<{data: ToeTemplateModel}>(this.API_URL + `/${id}`, {headers}).pipe(
            map(res => res.data)
        );
    }

    create(template: ToeTemplateModel): Observable<ToeTemplateModel> {
        const headers = this.authService.getAuthHeaders();
        return this.http.post<{data: ToeTemplateModel}>(this.API_URL, template, {headers}).pipe(map(res => res.data));
    }

    update(id: number, template: ToeTemplateModel): Observable<ToeTemplateModel> {
        const headers = this.authService.getAuthHeaders();
        return this.http.put<{data: ToeTemplateModel}>(this.API_URL + `/${id}`, template, {headers}).pipe(map(res => res.data));
    }

    delete(id: number): Observable<{sucess: boolean, id: number}> {
        const headers = this.authService.getAuthHeaders();
        return this.http.delete<{sucess: boolean, id: number}>(this.API_URL + `/${id}`, {headers});
    }

    duplicate(template: ToeTemplateModel): Observable<ToeTemplateModel> {
        const headers = this.authService.getAuthHeaders();
        return this.http.post<{data: ToeTemplateModel}>(this.API_URL + '/duplicate', template, {headers}).pipe(map(res => res.data));
    }
}